/**
 * Owner: Masa Bayu
 * File: id.ts
 * Date:Time: 2026-09-05 06:46
 * Description: Stable identity type for QXW objects.
 */
export function createQXId(prefix) {
    return `${prefix}_${crypto.randomUUID()}`;
}
//# sourceMappingURL=id.js.map